import {
    headers, getVendorAuditTrackerListUrl, GET_VENDOR_AUDIT_TRACKER_LIST,
    GET_HALL_VIEW_AUDIT_TRACKER_LIST,
    getHallViewAuditTrackerListUrl,
    getLayoutViewAuditTrackerListUrl,
    GET_LAYOUT_VIEW_AUDIT_TRACKER_LIST
} from "../../../utils/constants"
import { axiosPost, axiosGet } from "../../../react_axios/Axios"
import moment from 'moment';

export const getHallViewAuditTrackerList_action = (HallID, StallID, ExhRegistrationNo, ExhCompany, VendorCompany, Status,ZoneID,ServiceID) => async (dispatch) => {

    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            HallID: HallID != '' ? HallID : null,
            StallID: StallID != '' ? StallID : null,
            ExhRegistrationNo: ExhRegistrationNo != '' ? ExhRegistrationNo : null,
            ExhCompany: ExhCompany != '' ? ExhCompany : null,
            VendorCompany: VendorCompany != '' ? VendorCompany : null,
            Status: Status != '' ? Status : null,
            ZoneID: ZoneID != '' ? ZoneID : null,
            ServiceID: ServiceID != '' ? ServiceID : null,
        }

        const res = await axiosGet(getHallViewAuditTrackerListUrl, params, headers);
        dispatch({
            type: GET_HALL_VIEW_AUDIT_TRACKER_LIST,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }

}

export const getLayoutViewAuditTrackerList_action = (HallID, StallID, ExhRegistrationNo, ExhCompany, VendorCompany, Status,ZoneID,ServiceID) => async (dispatch) => {

    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID')
        }

        const res = await axiosGet(getLayoutViewAuditTrackerListUrl, params, headers);
        dispatch({
            type: GET_LAYOUT_VIEW_AUDIT_TRACKER_LIST,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }

}